type Props = {
  titleLabel: string
  titleKey: string
  fields: Record<string, string>
  data: object
}

export const SelectOptionDetails = ({ titleLabel, titleKey, fields, data }: Props) => {
  return (
    <div
    style={{
      display: "flex",
      flexDirection: "column",
      gap: 4,
      padding: "4px 0",
      lineHeight: 1.25,
    }}
  >
    <div
      style={{
        fontWeight: 600,
        fontSize: 14,
      }}
    >
      {titleLabel}: {data[titleKey]}
    </div>

    <div
      style={{
        display: "grid",
        gridTemplateColumns: "auto 1fr",
        columnGap: 8,
        rowGap: 2,
        fontSize: 12,
        // color: "rgba(0, 0, 0, 0.65)",
      }}
    >
      {Object.entries(fields).map(([label, fieldKey]) => (
        <>
        <span style={{ fontWeight: 500 }}>{label}:</span>
        <span>{data[fieldKey] || "—"}</span>
        </>
      ))}
    </div>
  </div>
  )
}
